<style lang="scss" scoped>
img {
  max-height: 200px;
}
</style>

<template>
  <td>
    <div class="d-flex align-items-center justify-content-around">
      <img
        v-if="model.is_image"
        class="media"
        :src="`${content}?height=100&width=100`"
        @click="$modal.show('image-modal', { image: content })"
      />
      <audio
        v-if="model.is_audio"
        class="media"
        :src="content"
        controls
      ></audio>
    </div>
    <image-modal></image-modal>
  </td>
</template>

<script lang="babel">
import ImageModal from "@/components/ImageModal.vue";
export default {
    components: {
      ImageModal,
    },
    props: ['content','model'],
};
</script>
